import { Box, BoxProps } from '@air/zephyr';
import Image from 'next/image';

import { MediaData } from '~/lib/contentful/custom-types';

export const WorthlessStudiosHeroTemplateAssetThree = ({ file, tx }: MediaData & Pick<BoxProps, 'tx'>) => {
  return (
    <Box tx={tx}>
      <Box
        tx={{
          position: 'relative',
          width: '91.4%',
          transform: 'rotate(5deg)',
          '> span': { display: 'block !important', borderRadius: 4 },
        }}
      >
        <Box
          tx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'pigeon800',
            borderRadius: 4,
            transform: 'translateY(-5%) translateX(9%)',
          }}
        />
        <Image height={file.details.image.height} src={`http:${file.url}`} width={file.details.image.width} />
      </Box>
    </Box>
  );
};
